import { render, staticRenderFns } from "./PortListBlock.vue?vue&type=template&id=8d672408&scoped=true"
import script from "./PortListBlock.vue?vue&type=script&lang=js"
export * from "./PortListBlock.vue?vue&type=script&lang=js"
import style0 from "./PortListBlock.vue?vue&type=style&index=0&id=8d672408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d672408",
  null
  
)

export default component.exports